import { Facebook, Instagram, LinkedIn, YouTube } from "@mui/icons-material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import {
  Box, Container,
  Divider,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  TextField,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import logo from "../Assets/G Sports/PNG/Asset 4@4x.png";
import footerimg from "../Assets/images/footergoingup.jpg";
import { COLORS } from "../Constants/styles";
const quickLinks = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Our Services', href: '/ourservices' },
  { label: 'ChampionsForge', href: '/championsforge' },
  { label: 'Careers', href: '/careers' },
  { label: 'Contact Us', href: '/contact' },
  { label: 'FAQs', href: '#' },
];

const FooterSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.body.offsetHeight;
    setIsVisible(scrollPosition >= pageHeight - 50);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Main Footer */}
      <Box component="footer" sx={{ bgcolor: COLORS.greyBG, pt: 8, pb: 2, pl: 4 }}>
        <Container maxWidth="xl">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7 }}
          >
            <Grid container spacing={8}>
              <Grid item xs={12} md={5}>
                <Box display="flex" alignItems="center" gap={2} mb={3}>
                  <img src={logo} alt="Logo" width={60} />
                  <Typography variant="h6" sx={{ color: COLORS.accentDarkGreen, letterSpacing: 1 }}>
                    Building Happy Children Through Better Sports Education.
                  </Typography>
                </Box>
                <Typography variant="h6" gutterBottom>Structured Sports Education for Schools</Typography>
                <Typography variant="body3" mb={2}>
                  Empowering schools through curriculum-aligned Sports & Physical Education, qualified coaches, digital learning, and complete sports ecosystem solutions.
                </Typography>
                {/* <Box component="form" display="flex" gap={1}>
                  <TextField placeholder="Enter email" size="small" fullWidth sx={{ bgcolor: "#fff" }} />
                  <IconButton
                    type="submit"
                    sx={{
                      bgcolor: COLORS.accentLime,
                      color: COLORS.accentDarkGreen,
                      "&:hover": { bgcolor: COLORS.accentDarkGreen, color: COLORS.accentLime },
                      borderRadius: "8px",
                    }}
                  >
                    <ArrowForwardIcon />
                  </IconButton>
                </Box> */}
              </Grid>

              <Grid item xs={12} md={7}>
                <Grid container spacing={1}>

                  {/* Column 1: Quick Links */}
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom sx={{ color: COLORS.accentDarkGreen, letterSpacing: 1 }}>Quick Links</Typography>
                    <List dense sx={{lineHeight:0.1}}>
                      {quickLinks.map((link) => (
                        <ListItem key={link.label} disableGutters>
                          <Link href={link.href} underline="none" variant="body3"
                            sx={{ color: COLORS.accentBlackTransparent, transition: 'color 0.2s ease, font-weight 0.2s ease', '&:hover': { color: COLORS.accentDarkGreen, fontWeight: 700 } }}>
                            {link.label}
                          </Link>
                        </ListItem>
                      ))}
                    </List>
                  </Grid>



                  {/* Column 2: Social */}
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6"  gutterBottom sx={{ color: COLORS.accentDarkGreen, letterSpacing: 1 }}>Follow Our Journey</Typography>
                    <List dense sx={{fontSize: '1.25rem', lineHeight: 0 }}>
                      {[
                        { label: 'Facebook', icon: <Facebook fontSize="small" />, href: '#' },
                        { label: 'Instagram', icon: <Instagram fontSize="small" />, href: 'https://www.instagram.com/grassroots_sports_education?igsh=NWN2em0wYTNqd3Zz' },
                        { label: 'LinkedIn', icon: <LinkedIn fontSize="small" />, href: 'https://www.linkedin.com/company/grassroots-sports-education-and-services-pvt-ltd/' },
                        { label: 'YouTube', icon: <YouTube fontSize="small" />, href: '#' },
                      ].map((s) => (
                        <ListItem key={s.label} disableGutters sx={{ py: 0.25 }}>
                          <Box
                            component="a"
                            href={s.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              display: 'flex', alignItems: 'center', gap: 1,
                              fontSize: '0.75rem', fontFamily: 'Inter',
                              color: COLORS.accentBlackTransparent,
                              textDecoration: 'none',
                              transition: 'color 0.2s ease',
                              '&:hover': { color: COLORS.accentDarkGreen, fontWeight: 700 },
                            }}
                          >
                            {s.icon} {s.label}
                          </Box>
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                  {/* Column 3: Contact Us */}
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom sx={{ color: COLORS.accentDarkGreen, letterSpacing: 1 }}>Contact Us</Typography>
                    <List dense disablePadding>
                      <ListItem disableGutters sx={{ py: 0.25 }}>
                        <Link href="mailto:info@grassrootssports.in" underline="none" color={COLORS.accentBlackTransparent}
                          sx={{ display: 'flex', alignItems: 'center', gap: 0.75, fontSize: '0.75rem', fontFamily: 'Inter' }}>
                          <EmailOutlinedIcon sx={{ fontSize: '0.95rem' }} /> info@grassrootssports.in
                        </Link>
                      </ListItem>
                      <ListItem disableGutters sx={{ py: 0.25 }}>
                        <Link href="tel:+919578399299" underline="none" color={COLORS.accentBlackTransparent}
                          sx={{ display: 'flex', alignItems: 'center', gap: 0.75, fontSize: '0.75rem', fontFamily: 'Inter' }}>
                          <LocalPhoneOutlinedIcon sx={{ fontSize: '0.95rem' }} /> +91 95783 99299
                        </Link>
                      </ListItem>
                      <ListItem disableGutters sx={{ py: 0.25, alignItems: 'flex-start' }}>
                        <LocationOnOutlinedIcon sx={{ fontSize: '0.95rem', mt: '2px', color: COLORS.accentBlackTransparent, flexShrink: 0 }} />
                        <Typography variant="body3" color={COLORS.accentBlackTransparent} sx={{ ml: 0.75 }}>
                          No 9/103, Mariappan Nagar, M. Perumapalayam, Valapady, Salem - 636111, Tamil Nadu
                        </Typography>
                      </ListItem>
                      <ListItem disableGutters sx={{ py: 0.25 }}>
                        <Link href="https://www.grassrootssports.in" underline="none" color={COLORS.accentBlackTransparent}
                          sx={{ display: 'flex', alignItems: 'center', gap: 0.75, fontSize: '0.75rem', fontFamily: 'Inter' }} target="_blank" rel="noopener">
                          <LanguageOutlinedIcon sx={{ fontSize: '0.95rem' }} /> www.grassrootssports.in
                        </Link>
                      </ListItem>
                    </List>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </motion.div>
        </Container>

        <Divider sx={{ my: 4 }} />

        <Container maxWidth="xl" sx={{ mt: 6 }}>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, gap: 2 }}>
              <Typography variant="body3" color={COLORS.accentBlackTransparent}>
                © 2026 Grassroots Sports Education & Services Pvt. Ltd. All Rights Reserved.
              </Typography>
              <Box display="flex" gap={3}>
                <Link href="#" color={COLORS.accentBlackTransparent} variant="body3" underline="none">Privacy</Link>
                <Link href="#" color={COLORS.accentBlackTransparent} variant="body3" underline="none">Terms</Link>
                <Link href="#" color={COLORS.accentBlackTransparent} variant="body3" underline="none">FAQs</Link>
              </Box>
            </Box>
          </motion.div>
        </Container>
      </Box>

      {/* Scroll to Top Sticky Footer */}
      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          width: '100%',
          backgroundImage: `url(${footerimg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          textAlign: 'center',
          py: 4,
          overflow: 'hidden',
          zIndex: 10,
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
      >
        <Typography variant="h5" sx={{ color: 'white', mb: 2 }}>
          Where <Box component="span" sx={{ color: COLORS.accentLime }}>sports</Box> bring people <Box component="span" sx={{ color: COLORS.accentLime }}>together.</Box>
        </Typography>

        <IconButton
          href="#top"
          sx={{
            backgroundColor: COLORS.accentLime,
            color: COLORS.accentDarkGreen,
            '&:hover': { backgroundColor: COLORS.accentDarkGreen, color: COLORS.accentLime },
            mt: 2,
          }}
        >
          <ArrowUpwardIcon />
        </IconButton>
      </Box>
    </>
  );
};

export default FooterSection;
